import { defineMessages } from 'react-intl';

export default defineMessages({
    linkBankAccountTitle: {
        id: '_.modal.link_bank_account.title',
        defaultMessage: 'Business bank details'
    },
    linkBankAccountDescription: {
        id: '_.modal.link_bank_account.description',
        defaultMessage: `This is where we'll send your funds. This must be your business account, a personal account will not be funded.`
    },
    sortCode: {
        id: '_.modal.link_bank_account.sort_code',
        defaultMessage: 'Sort code'
    },
    accountNumber: {
        id: '_.modal.link_bank_account.account_number',
        defaultMessage: 'Account number'
    },
    iban: {
        id: '_.modal.link_bank_account.iban',
        defaultMessage: 'IBAN'
    },
    promptSave: {
        id: '_.modal.link_bank_account.save',
        defaultMessage: 'Link this account'
    },
    requiredField: {
        id: '_.link_bank_account.required_field',
        defaultMessage: 'Required field'
    },
    mandateRequired: {
        id: '_.link_bank_account.mandate_required',
        defaultMessage:
            'Check the box to continue. If you do not want a direct debit, please contact us by phone.'
    },
    invalidIBAN: {
        id: '_.link_bank_account.invalid_iban',
        defaultMessage: 'Invalid IBAN'
    }
});
